module.exports = __webpack_public_path__ + "img/chad.d2725ed6.svg";